import { useMemo } from 'react';

import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { getDefaultParams } from '~/utils/search/getDefaultSearchParams';

export const useDefaultParams = () => {
  const { country } = useBusinessUnitContext();

  return useMemo(() => getDefaultParams(country), [country]);
};
